
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, useDisclosure, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import HelpModal, { FAQ } from '../../components/Modals/HelpModal';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import SkillSingleInputGenerateMorePlayground from '../../components/Skill/SingleInputGenerateMore/SkillSingleInputGenerateMorePlayground';
import SkillOptions, { Option } from '../../components/Skill/SkillOptions';
import { COOKIE_OPTIONS } from '../../constants/cookies';
import { GPT_3_TOKEN_LENGTH } from '../../constants/gpt3';
import { STORY_TYPE } from '../../constants/options';
import { SKILL_STORY_WRITING_EXAMPLES } from '../../constants/skillExamples';
import { getFourRandomSkills, REDACTION_SKILLS, SKILL_STORY_WRITING } from '../../constants/skills';
import { useOptionCookie } from '../../hooks/useOptionCookie';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { deleteCookieClient } from '../../utils/cookieHelpers';
import { SkillProvider } from '../../utils/SkillContext';
const SkillStoryWriting = ({ otherServices }: any) => {
    const helpModal = useDisclosure();
    const { t, lang } = useTranslation('skill-story-writing');
    const maxLength = 750 * GPT_3_TOKEN_LENGTH;
    const skillsGroup = REDACTION_SKILLS;
    const options = [
        { value: STORY_TYPE.FANTASY, text: t('skill_story_writing_fantasy') },
        { value: STORY_TYPE.THRILLER, text: t('skill_story_writing_thriller') },
        { value: STORY_TYPE.HORROR, text: t('skill_story_writing_horror') },
        { value: STORY_TYPE.SCIENCE_FICTION, text: t('skill_story_writing_sf') },
        { value: STORY_TYPE.EPIC, text: t('skill_story_writing_epic') },
        { value: STORY_TYPE.COMIC, text: t('skill_story_writing_comic') },
        { value: STORY_TYPE.LYRICAL, text: t('skill_story_writing_lyrical') },
        { value: STORY_TYPE.ROMANTIC, text: t('skill_story_writing_romantic') },
        { value: STORY_TYPE.REALISTIC, text: t('skill_story_writing_realistic') },
    ];
    const selectedStoryType = useOptionCookie('storyType', options, 0);
    const [selectedOption, setSelectedOption] = useState<Option>(options[0]);
    useEffect(() => {
        setSelectedOption(selectedStoryType);
        deleteCookieClient(COOKIE_OPTIONS);
    }, [selectedStoryType]);
    const faq: FAQ[] = [
        { question: t('help_modal_story_how_to_title'), response: t('help_modal_story_how_to_text') },
        {
            question: t('help_modal_story_no_answer_title'),
            response: t('help_modal_story_no_answer_text'),
        },
    ];
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        {helpModal.isOpen && (<HelpModal isOpen={helpModal.isOpen} onClose={helpModal.onClose} FAQ={faq}/>)}
        <HeadModule title='meta_title_skill_story_writing' description='meta_description_skill_story_writing'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_STORY_WRITING} skillExamples={SKILL_STORY_WRITING_EXAMPLES} skillGroup={skillsGroup}>
              <SkillSingleInputGenerateMorePlayground maxLength={maxLength} selectedOption={{ storyType: selectedOption.value }}>
                <SkillOptions title={t('skill_story_writing_subtitle')} options={options} selectedOption={selectedOption} setSelectedOption={setSelectedOption} onOpenHelpModal={helpModal.onOpen}/>
              </SkillSingleInputGenerateMorePlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillStoryWriting;

    async function __Next_Translate__getStaticProps__19bb2fd5b77__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/redaction/story-writing',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b77__ as getStaticProps }
  